import { create } from "zustand";

type SelfHostedEnabledCloudIntegrationsStore = {
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
  awsIntegrationsEnabled: boolean | undefined;
  setAwsIntegrationsEnabled: (awsIntegrationsEnabled: boolean) => void;
  azureIntegrationsEnabled: boolean | undefined;
  setAzureIntegrationsEnabled: (azureIntegrationsEnabled: boolean) => void;
};

export const useSelfHostedEnabledCloudIntegrationsStore =
  create<SelfHostedEnabledCloudIntegrationsStore>((set) => ({
    isLoading: false,
    setIsLoading: (isLoading) => set({ isLoading }),
    awsIntegrationsEnabled: undefined,
    setAwsIntegrationsEnabled: (awsIntegrationsEnabled) => set({ awsIntegrationsEnabled }),
    azureIntegrationsEnabled: undefined,
    setAzureIntegrationsEnabled: (azureIntegrationsEnabled) => set({ azureIntegrationsEnabled }),
  }));
